// @flow
import BuilderNavBar from 'components/BuilderNavBar'
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import BuilderSideMenu from 'pages/FormBuilder/Components/BuilderSideMenu'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import { Prompt, useHistory } from 'react-router-dom'
import styled from 'styled-components'
import Flex from 'ui/atoms/Flex'
import FlexBox from 'ui/atoms/FlexBox'
import FormContainer from 'ui/atoms/FormContainer'

import { UnsavedChangesModal } from '@/components/UnsavedChangesModal/UnsavedChangesModal'

const FullHeightFlex = styled(Flex)`
  height: 100%;
`

type Props = {
  children: React.Node,
  handleBuild?: () => void,
  handleSave: () => void | Promise<void>,
  handlePreview: () => void,
  handleSettings?: () => void,
  previewDisabled: boolean,
  promptMessage?: string | Function,
  saveLoading: boolean,
  settingsActive: boolean,
  sideMenuContent?: React.Node,
  title: string,
  hidePreview?: boolean,
}

function LayoutWithSidebar({
  children,
  handleBuild,
  handleSave,
  handlePreview,
  handleSettings,
  previewDisabled,
  promptMessage,
  saveLoading,
  sideMenuContent = null,
  title,
  hidePreview = false,
}: Props): React.Node {
  const history = useHistory()
  const { isDirty, reloadFormData } = React.useContext(FormBuilderContext)

  const isSettingsActive = history.location.pathname.includes('settings')
  const isDesignActive = history.location.pathname.includes('design')
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {promptMessage && <Prompt message={promptMessage} />}
      <BuilderNavBar
        handleBuild={handleBuild}
        handlePreview={handlePreview}
        handleSave={handleSave}
        handleSettings={handleSettings}
        hidePreview={hidePreview}
        previewDisabled={previewDisabled || isDirty}
        saveLoading={saveLoading}
      />
      <div className="h-[calc(100%-120px)]">
        <FullHeightFlex>
          {!isDesignActive ? (
            <BuilderSideMenu>{sideMenuContent}</BuilderSideMenu>
          ) : null}
          {isSettingsActive || isDesignActive ? (
            children
          ) : (
            <FlexBox>
              <FormContainer>{children}</FormContainer>
            </FlexBox>
          )}
        </FullHeightFlex>
      </div>
      <UnsavedChangesModal
        {...{
          shouldBlock: isDirty,
          confirmDiscard: reloadFormData,
        }}
      />
    </>
  )
}

export default LayoutWithSidebar
